import {
  Box,
  ButtonProps,
  Grow,
  IconButton,
  makeStyles,
  styled,
} from '@material-ui/core';
import { activeChatSelector } from '@src/selectors/chats';
import useDebouncedValue from '@src/utils/useDebouncedValue';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import RoundedButton from '../UI/RoundedButton';
import { ArrowDownIcon } from './SvgIcons';

const MAX_COUNT = 99;

const useStyles = makeStyles(theme => ({
  iconButton: {
    color: theme.palette.primary.main,
    padding: 2,
  },
  countBadge: {
    position: 'absolute',
    color: '#FFFFFF',
    backgroundColor: theme.palette.primary.main,
    width: '29px',
    height: '22px',
    borderRadius: '999px ',
    textAlign: 'center',
    right: -15,
    bottom: '10px',
    fontSize: '12px',
    fontWeight: 700,
  },
}));

const ScrollToBottomButtonStyled = styled(RoundedButton)(({ theme }) => ({
  position: 'sticky',
  left: 'calc(100% - 40px)',
  marginRight: 16,
  bottom: 8,
  zIndex: 10,
  boxShadow: '0px 2px 4px 0px #00000040',
  // Theme tokens (white / dark card) + the shared floating-surface border so
  // the button isn't a white blob on the dark timeline.
  backgroundColor: theme.palette.background.paper,
  border: theme.popoverSurface.border,
}));

const ScrollToBottomButton: React.FC<ButtonProps & { visible: boolean }> = ({
  visible,
  ...props
}) => {
  const { iconButton, countBadge } = useStyles();

  const [visibleDebounced, setVisibleImmediately] = useDebouncedValue(
    visible,
    800
  );

  const activeChat = useSelector(activeChatSelector);

  useEffect(() => {
    if (!visible) setVisibleImmediately(false);
  }, [setVisibleImmediately, visible]);

  return (
    <Grow in={visibleDebounced} mountOnEnter unmountOnExit timeout={350}>
      <ScrollToBottomButtonStyled size="small" variant="contained" {...props}>
        {activeChat?.messagesSinceLastResponse > 0 && (
          <Box position="absolute">
            <Box className={countBadge}>
              {activeChat.messagesSinceLastResponse > MAX_COUNT
                ? `+${MAX_COUNT}`
                : activeChat.messagesSinceLastResponse}
            </Box>
          </Box>
        )}
        <IconButton size="small" color="inherit" className={iconButton}>
          {ArrowDownIcon}
        </IconButton>
      </ScrollToBottomButtonStyled>
    </Grow>
  );
};

export default ScrollToBottomButton;
